import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CommonFacade from '../../../redux/common/Common.facade';
import { useSelector } from 'react-redux';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

export const Toast = () => {
  const {
    toast: { duration, open, message ,severity},
  } = useSelector((state) => state.common);

  const { handleToaster } = CommonFacade();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    handleToaster({ open: false });
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        severity={severity}
        onClose={handleClose}
        sx={{
          width: '100%',
          background: '#333 !important',
          borderRadius: '4 !important',
          color: '#FFFFFF !important',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
